import type { DropResult } from "react-beautiful-dnd";

/**
 * Reorders a list from a react-beautiful-dnd {@link DropResult}.
 * Returns null when the drop does not change order or is cancelled.
 */
export function reorderWithDragResult<T>(
  items: readonly T[],
  result: DropResult,
): T[] | null {
  const { source, destination } = result;
  if (!destination) return null;
  if (source.droppableId !== destination.droppableId) return null;
  if (source.index === destination.index) return null;

  const next = Array.from(items);
  const [removed] = next.splice(source.index, 1);
  next.splice(destination.index, 0, removed);
  return next;
}
